import {AbuseCheckStatus} from "services/abuseWordsService";

export const AbuseCheckStatusLabels: Record<AbuseCheckStatus, string> = {
    [AbuseCheckStatus.Pending]: 'Ожидается',
    [AbuseCheckStatus.InProgress]: 'В прогрессе',
    [AbuseCheckStatus.Completed]: 'Готово',
    [AbuseCheckStatus.Cancelled]: 'Отмена',
    [AbuseCheckStatus.Failed]: 'Ошибка',
};